import { geocodeByAddress } from 'react-places-autocomplete';
import { BaseMap } from './src/BaseMap';
import { Map } from './src/Map';
import { Property } from './src/Property';
import { AddressSearchBar } from './src/AddressSearchBar';
import { AddressSearchBarWithGoogleMapScript } from './src/AddressSearchBarWithGoogleMapScript';

Map.Property = Property;

export {
  Map,
  BaseMap,
  AddressSearchBar,
  AddressSearchBarWithGoogleMapScript,
  geocodeByAddress,
};
